<div class="profile-container">
    <div class="">
        <div class="profile-content">
          <!-- <button class="add-task" data-toggle="modal" data-target="#exampleModal">Add</button> -->

            <div class="personal-details">
                <div class="row">
                    <div class="col-md-4 col-lg-4">
                        <!-- <div class="col-md-6 col-lg-6">
                            <select class="form-control" [(ngModel)]="userId">
                                <option *ngFor="let user of usersList" [value]="user.userId">{{user.userName}}</option>
                            </select>
                        </div>
                        <div class="col-md-6 col-lg-6">
                            <select name="" id="" class="form-control" [(ngModel)]="status">
                                <option value="WORK_IN_PROGRESS">WORK_IN_PROGRESS</option>
                                <option value="PENDING">PENDING</option>
                                <option value="COMPLETED">COMPLETED</option>
                                <option value="DEFERRED">DEFERRED</option>
                                <option value="PARTIALLY_COMPLETED">PARTIALLY_COMPLETED</option>
                                <option value="FORCE_CLOSED">FORCE_CLOSED</option>
                                <option value="CLOSED">CLOSED</option>
                            </select>                        
                        </div> -->
                    </div>
                    <div class="col-md-8 col-lg-8">
                        <div class="col-md-5 col-lg-5">
                            <input type="date" [(ngModel)]="startDate" class="form-control">
                        </div>
                        <div class="col-md-5 col-lg-5">
                            <input type="date" [(ngModel)]="endDate" class="form-control">
                        </div>
                        <div class="col-md-2 col-lg-2">
                            <button (click)="searchFilter()" class="btn btn-primary">search</button>
                        </div>
                    </div>
                </div>
                <!-- <h4 class="personal-details-title">Task Master</h4> -->
                <table class="table table-striped" >
                    <thead>
                      <tr>
                        <th scope="col">Id</th>
                        <th scope="col">Type</th>
                        <!-- <th scope="col">Assigned To</th> -->
                        <th scope="col">Description</th>
                        <th scope="col">Subject</th>
                        <th scope="col">Status</th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let filteredData of filteredData | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                        };let i = index">
                        <th scope="col">{{filteredData.ctid}}</th>
                        <th scope="col">{{filteredData.typeName}}</th>
                        <!-- <th scope="col">{{filteredData.assignedToUserName}}</th> -->
                        <th scope="col">{{filteredData.details}}</th>
                        <th scope="col">{{filteredData.heading}}</th>
                        <th scope="col">{{filteredData.latestTicketStatus}}</th>
                      </tr>
                    </tbody>
                </table>
                <div class="pagination-block" *ngIf="filteredData.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                  </div>
                  <h5 class="text-center" *ngIf="filteredData.length == 0">no tickets</h5>
            </div>

        </div>
    </div>
</div>